'use client';

import { Slot } from '@radix-ui/react-slot';
import { ComponentProps, Key, useEffect, useRef } from 'react';

import { useObserve } from './IntersectionProvider';

type IntersectionTriggerProps = Omit<ComponentProps<'div'>, 'id'> & {
    id: Key;
    asChild?: boolean;
};

export function IntersectionTrigger({
    asChild,
    id,
    ...props
}: IntersectionTriggerProps) {
    const Comp = asChild ? Slot : 'div';
    const context = useObserve();

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!ref.current) {
            console.warn(`IntersectionTrigger ref undefined for id: ${id}`);
            return;
        }

        return context.observe(id, ref.current);
    }, [id, ref]);

    return <Comp {...props} ref={ref} />;
}
